import React from "react";
import Typography from "@material-ui/core/Typography";
import CopyToClipboardChip from 'hcla-web-frontend-primitives/app/components/primitives/Chips/CopyToClipboardChip';

export interface StatsData {
  title: string;
  text?: number | string;
  label: number | string;
}

export interface StatsTableProps {
  data: StatsData[];
}

class StatsTable extends React.PureComponent<StatsTableProps> {
  render() {
    const { data } = this.props;
    if (!data || !data.length) {
      return null;
    }
    return (
      <table style={{ borderSpacing: '8px 4px', textAlign: 'center' }}>
        <tr>
          {
            data.map((item: StatsData) => (
              <th>
                <Typography color="textPrimary">{item.title}</Typography>
              </th>
            ))
          }
        </tr>
        <tr>
          {
            data.map((item: StatsData) => (
              <td style={{ borderTop: '1px solid' }}>
                <CopyToClipboardChip
                  color="default"
                  style={{ marginTop: '8px' }}
                  clipboardProps={{
                    text: item.text ? item.text : item.label,
                  }}
                  label={<Typography color="textPrimary">{item.label}</Typography>}
                />
              </td>
            ))
          }
        </tr>
      </table>
    );
  }
}

export default StatsTable;
